/* eslint-disable no-dupe-keys */
export default {
  nvr_channel: {
    name: '监控摄像头',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '摄像头名',
      charge_station: '充电站',
      config: '配置',
      position: '排序',
      picture_url: '图片地址',
      picture_updated_at: '图片更新时间',
      parking_sys_station_sn: '停车系统站编号',
      parking_sys_camera_sn: '停车系统摄像头编号',
      note: '备注',
      created_at: '创建时间',
      updated_at: '更新时间',
      picture: '图片',
      nvr_serial_number: '云摄像头编号',
      channel_number: '云摄像头通道'
    },
    // Enum的属性
    is_hds: {
      true: '高清',
      false: '标清'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '摄像头名/充电站/备注'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      play: '播放视频',
      third_party_service_traces: '摄像头服务日志'
    },
    titles: {
      base_info: '基本信息',
      camera_config: '摄像头配置',
      capture_info: '摄像头图片',
      binding_parking_place: '选择摄像头监控范围',
      chargers_info: '车位信息'
    },
    btn: {
      refresh: '刷新截图',
      play_video: '播放视频',
      setting: '设置播放参数',
      delete: '删除摄像头',
      capture: '截图',
      full_screen: '全屏',
      capture_picture: '捕获图片',
      binding_parking_place_confirm: '绑定选中车位'
    },
    labels: {
      charger_name: '桩名',
      charger_sn: '桩编号',
      charger_status: '桩状态',
      nvr_channels: '已绑定摄像头',
      event_time: '发生时间',
      parking_place: '车位',
      event: '事件'
    },
    events: {
      parking_lock_up: '升锁',
      parking_lock_down: '降锁',
      start_charging: '开始充电',
      finish_charging: '结束充电',
      parking_lock_control: '地锁控制'
    },
    tips: {
      send_capture_picture_success: '已下发截图指令，等待摄像头图片回传（时间 3秒 ~ 1分钟不等）',
      full_screen: '双击视频进入/退出全屏模式',
      play_left_time: '{0} 秒后自动停止',
      in_hd_mode: '正在使用高清模式播放，请注意流量使用',
      success_binding_parking_palces: '成功绑定车位',
      success_remove_binding_parking_palces: '成功解除车位绑定',
      remove_parking_place_content_html: '确定要解除绑定车位 {0}',
      keyboard_control: '支持键盘 ← → 控制时间轴'
    }
  }
}
